<template lang="pug">
  .home
    .container-fluid
      .row
        .col-md-12
          NewSimulationForm(v-bind:newSimulation="newSimulation" v-on:start="startNewSimulation")
        //- .col-md-12
        //-   ContactMe
        .col-md-12
          RecentlyViewedReports
</template>

<script>
import NewSimulationForm from '@/components/NewSimulationForm'
import ContactMe from '@/components/ContactMe'
import RecentlyViewedReports from '@/components/RecentlyViewedReports'

export default {
  name: 'home',
  data: () => {
    return {
      newSimulation: {
        url: '',
        device: 'sp',
        email: 'miyanaga@ideamans.com',
      },
    }
  },
  created: () => {
  },
  methods: {
    startNewSimulation: function() {
      this.$router.push({ name: 'report', params: {id: 'ideamans-dev'} });
    }
  },
  components: {
    NewSimulationForm,
    ContactMe,
    RecentlyViewedReports,
  },
  watch: {
  }
}
</script>
